import {colors} from "../configuration/colors";

/**
 * Helper function DSSDebug.js
 *
 * @namespace DSSDebug
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/DSSDebug.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * @function DSSDebug.printDSSDebugInfo
 */
export const printDSSDebugInfo = (algorithm, patientId, currentAlgorithmVersion) => {
    curLineIndex = 0;

    const algorithmVersion = algorithm.version ||  '0.0.0';
    currentAlgorithmVersion = currentAlgorithmVersion ||  '0.0.0';

    printHR();
    console.log('  _____   _____ _____   _____  ______ ____  _    _  _____ \n' +
        ' |  __ \\ / ____/ ____| |  __ \\|  ____|  _ \\| |  | |/ ____|\n' +
        ' | |  | | (___| (___   | |  | | |__  | |_) | |  | | |  __ \n' +
        ' | |  | |\\___ \\\\___ \\  | |  | |  __| |  _ <| |  | | | |_ |\n' +
        ' | |__| |____) |___) | | |__| | |____| |_) | |__| | |__| |\n' +
        ' |_____/|_____/_____/  |_____/|______|____/ \\____/ \\_____|\n' +
        '                                                          ')
    printHR();
    console.log('Please provide the following data when reporting tickets:')
    console.log('🤒 Patient ID:\t\t\t' + patientId);
    console.log('📋 Algorithm ID:\t\t' + algorithm.id);
    console.log('🔢 Algorithm version:\t' + algorithmVersion + ` (current ${currentAlgorithmVersion})`);
    printHR();

    if (algorithmVersion !== currentAlgorithmVersion){
        console.log("%c" + `Warning the version of this executed algorithm (${algorithmVersion}) is not the latest version (${currentAlgorithmVersion})`, `font-weight:bold; color: ${colors.coro.yellow};`);
        printHR();
    }

    if (!algorithm.paths)
        return;

    algorithm.paths.forEach(path => {
        console.log(getLineNumber() + "%c" + '🌲 Tree:\t\t' + path.key, `font-weight:bold; color: ${getCurrentColor()};`);
        console.log(getLineNumber() + "%c" + '   🆔:\t\t\t' + path.id, `font-weight:bold; color: ${getCurrentColor()};`);

        console.log(getLineNumber());

        path.steps.forEach(step => {
            if (step.question){
                console.log(getLineNumber() + stepTabs + "%c" + '♦ Step:\t\t' + `${step.question.text} (${step.question.key})`, `color: ${getCurrentColor()};`);
                console.log(getLineNumber() + stepTabs + "%c" + '  🆔:\t\t' + `${step.id})`, `color: ${getCurrentColor()};`);
                console.log(getLineNumber() + answerTabs + "%c" + '🖊️ Answer:\t' + `${step.answer}`, `color: ${getCurrentColor()};`);
            }else{
                console.log(getLineNumber() + stepTabs + "%c" + '♦ Step:\t\t' + `GENERAL`, `color: ${getCurrentColor()};`);
            }

            console.log(getLineNumber() + answerTabs + "%c" + '   Extra Info:\t' + `${step.parameters === '[]' ? '-' : ''}`, `color: ${getCurrentColor()};`);

            if (step.parameters && step.parameters !== '[]'){
                const parameters = JSON.parse(step.parameters);

                for (let infoKey in parameters){
                    console.log(getLineNumber() + extraInfoTabs + "%c" + `${infoKey}:\t\t${JSON.stringify(parameters[infoKey])}`, `color: ${getCurrentColor()};`);
                }
            }

            if (step.medicationRecommendations.length){
                console.log(getLineNumber());
                console.log(getLineNumber() + recommendationTabs + "%c" + 'Recommendations:', `font-weight:bold; color: ${recommendationColor};`);

                step.medicationRecommendations.forEach((medicationRecommendation, index) => {
                    console.log(getLineNumber() + recommendationDetailsTabs + "%c" + `Recommendation ${index + 1}:`, `font-weight:bold; color: ${recommendationColor};`);
                    console.log(getLineNumber() + recommendationDeepDetailsTabs + "%c" + `🆔:\t\t\t${medicationRecommendation.id}`, `font-weight:bold; color: ${recommendationColor};`);
                    console.log(getLineNumber() + recommendationDeepDetailsTabs + "%c" + `Text:\t\t\t${medicationRecommendation.medicationText}`, `font-weight:bold; color: ${recommendationColor};`);
                    console.log(getLineNumber() + recommendationDeepDetailsTabs + "%c" + `Medication Classes:\t${getMedicatonClassText(medicationRecommendation)}`, `font-weight:bold; color: ${recommendationColor};`);

                    if (medicationRecommendation.guidelineEntries.length){
                        console.log(getLineNumber() + recommendationDeepDetailsTabs + "%c" + 'Guidelines:', `font-weight:bold; color: ${recommendationColor};`);

                        medicationRecommendation.guidelineEntries.forEach((guidelineEntry, index) => {
                            const guideLine = guidelineEntry.guideLine;
                            console.log(getLineNumber() + guidelineDetailTabs + "%c" + `Guideline ${index + 1}:`, `font-weight:bold; color: ${recommendationColor};`);
                            console.log(getLineNumber() + guidelineDetailTabs + "%c" + `🆔 (entry): ${guidelineEntry.id}`, `font-weight:bold; color: ${recommendationColor};`);
                            console.log(getLineNumber() + guidelineDeepDetailTabs + "%c" + `Class:\t\t${guideLine.classLabel}\t/\tLevel of Evidence:\t${guideLine.levelOfEvidence}`, `font-weight:bold; color: ${recommendationColor};`);
                            console.log(getLineNumber() + guidelineDeepDetailTabs + "%c" + `Text:\t\t${guideLine.text}`, `font-weight:bold; color: ${recommendationColor};`);
                            console.log(getLineNumber() + guidelineDeepDetailTabs + "%c" + `Source:\t\t${guideLine.source}`, `font-weight:bold; color: ${recommendationColor};`);
                            console.log(getLineNumber() + guidelineDeepDetailTabs + "%c" + `Key:\t\t${guideLine.key}`, `font-weight:bold; color: ${recommendationColor};`);
                        });
                    }

                    console.log(getLineNumber());
                })
            }
        })

        incrementColor();
        printHR();
    });

    console.log('  ______ _____ _   _ _____  _____ _    _ \n' +
        ' |  ____|_   _| \\ | |_   _|/ ____| |  | |\n' +
        ' | |__    | | |  \\| | | | | (___ | |__| |\n' +
        ' |  __|   | | | . ` | | |  \\___ \\|  __  |\n' +
        ' | |     _| |_| |\\  |_| |_ ____) | |  | |\n' +
        ' |_|    |_____|_| \\_|_____|_____/|_|  |_|\n' +
        '                                               ')

    printHR();
}

const stepTabs = '\t';
const answerTabs = '\t\t\t\t';
const recommendationTabs = answerTabs;
const recommendationDetailsTabs = '\t\t\t\t\t';
const recommendationDeepDetailsTabs = recommendationDetailsTabs + '\t';
const extraInfoTabs = '\t\t\t\t\t\t';
const guidelineDetailTabs = recommendationDeepDetailsTabs + '\t';
const guidelineDeepDetailTabs = guidelineDetailTabs + '\t';

const recommendationColor = '#FFFFFF';

function getMedicatonClassText(medicationRecommendation){
    return medicationRecommendation.medicationClassRecommendations.map(medicationClassRecommendation => {
        const medicationClass = medicationClassRecommendation.medicationClass;

        return `${medicationClass.name}${medicationClassRecommendation.name ? ` (${medicationClassRecommendation.name})` : ''} [${medicationClass.key}]`;
    }).join(' OR ')
}

function printHR(){
    console.log('----------------------------------------------------------------------------------------------------');
}

function getCurrentColor(){
    return printColors[curColorIndex % printColors.length]
}

function incrementColor(){
    curColorIndex++;
}

function getLineNumber(){
    return (++curLineIndex).toString().padStart(4, ' ') + '.\t';
}

let curColorIndex = 0;
let curLineIndex = 0;

const printColors = [
    colors.coro.purpleish,
    colors.coro.blue,
    colors.coro.red,
    colors.coro.green,
]